<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>User / Employees Details</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!-- <b-form-input :formatter="capitalizeAll" size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
              <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>-->
              <b-button size="sm" variant="warning" @click="goToMain">New User</b-button>
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('All_Users_Report')"
                variant="outline-info">Export as Excel</b-button> -->
              <b-button
                :disabled="ExcelBtnName != 'Export' ? true : false"
                class="ml-3"
                @click="getReportsAss('All_Users_Report', 'Export')"
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <PurchaseApproverDetails
                :showButton="true"
                :payload="purchaseApproverPayload"
                class="ml-3"
              />
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <div>
          <h5 class="text-muted pull-right mt-2 ml-3">
            <small>{{ totalRows }} Entries</small>
          </h5>
        </div>
        <!-- User Interface controls -->
        <!-- <div>
         
        </div> -->
        <b-row>
          <b-col md="9">
            <label>Common</label>
            <b-form-group>
              <b-input-group>
                <b-form-input
                  :formatter="capitalizeAll"
                  v-model="filter"
                  placeholder="Type To Search"
                />
                <b-input-group-append>
                  <b-button
                    @click="
                      filter = '';
                      ClearFilter();
                    "
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-form-group></b-col
          >
          <b-col md="3">
            <label>Branch</label>
            <multi-select
              :options="$store.getters['common/getAllBranchList']"
              :selected-options="branch_items"
              v-model="Filter.branchfilter"
              placeholder="Select Branch"
              :multiple="true"
              id="Client"
              @select="SelectMultiBranch"
              :isDisabled="
                $sessionsStorage.get('designation') != 'Admin' &&
                $sessionsStorage.get('nameUser') != 'Bhavneesh'
                  ? true
                  : false
              "
            ></multi-select>
          </b-col>
        </b-row>

        <div class="table-responsive tableMain">
          <b-row class="align-content-end mt-3">
            <b-col class="mb-1" cols="6">
              <input
                type="checkbox"
                @click="SelectAll(vehicleSizeMaster)"
                v-model="isCheckAll"
              />
              <label>Select / Deselect All Count({{ this.AllUserIds.length }})</label>
              <b-button
                v-if="AllUserIds.length > 0"
                size="sm"
                @click="ShowModalUser"
                variant="outline-primary"
                class="ml-2"
                >Add Client</b-button
              >
              <Send-Email
                v-if="AllUserIds.length > 0"
                :AgentId="AllUserIds"
                :AllEmailId="AllEmailId"
                :type="'User'"
              ></Send-Email>
            </b-col>
          </b-row>
          <b-table
            show-empty
            stacked="md"
            :items="vehicleSizeMaster"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="isActive" slot-scope="row0">
              <input
                type="checkbox"
                v-bind:value="row0.item.userId"
                v-bind:id="row0.item.DepartmentId"
                v-model="AllUserIds"
                @change="updateSelectAll($event, row0.item)"
              />

              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="employeeName" slot-scope="row11">
              <div
                @click="viewUserPage(row11.item.userId)"
                class="showMoreData"
                v-if="row11.item.type == '1'"
              >
                <span>{{ row11.item.employeeName }}</span>
              </div>
              <div @click="viewUserPage(row11.userId)" v-else>
                <span>Client Name : {{ row11.item.clientName }}</span>
              </div>
            </template>
            <template slot="username" slot-scope="row1">
              <div
                @click="viewUserPage(row1.item.userId)"
                class="showMoreData"
                v-if="row1.item.type == '1'"
              >
                <span>Emp-username : {{ row1.item.username }}</span>
                <br />
                <span>Emp-Code :{{ row1.item.employeeCode }}</span>
                <br />
                <span>Emp-Designation: {{ row1.item.designation }}</span>
              </div>
              <div @click="viewUserPage(item1.userId)" class="showMoreData" v-else>
                <span>{{ row1.item.username }}</span>
              </div>
            </template>
            <template slot="acc_client_ids" slot-scope="row3">
              <b-button
                size="sm"
                style="margin-left:5px"
                variant="primary"
                @click="viewClients(row3.item)"
                >View Clients</b-button
              >
              <userBasedClient
                v-if="row3.item.userId"
                :PMC_title="'User Summary - ' + row3.item.employeeName"
                :PMC_USERID="row3.item.userId"
                :PMC_USERNAME="row3.item.username"
                :PMC_USERDESIG="row3.item.designation"
                :PMC_BranchClientPre="row3.item.branchclientPre"
                :PMC_TransportTypePre="row3.item.transportTypePre"
                :PMC_UserEmpName="row3.item.employeeName"
                :PMC_UserEmpCode="row3.item.employeeCode"
              />
            </template>
            <template slot="userId" slot-scope="row2">
              <div v-if="adminToggle == 'Admin'" :id="'row' + row2.item.userId">
                <md-switch
                  :id="'approval' + row2.item.userId"
                  name="approval"
                  class="md-primary"
                  :value="row2.item.isActive == 1 ? true : false"
                  @change="activateUser(row2.item)"
                >
                  <h6>
                    <br />
                    <b-badge style="margin-left: -45px">{{
                      row2.item.isActive == 1 ? "Active" : "In-Active"
                    }}</b-badge>
                  </h6>
                </md-switch>
              </div>
              <div v-else :id="'row' + row2.item.userId">
                <h6>
                  <b-badge>{{
                    row2.item.isActive == 1 ? "Active" : "In-Active"
                  }}</b-badge>
                </h6>
              </div>
            </template>
            <template slot="email" slot-scope="row3">
              <span>Contact No. : {{ row3.item.mobileNo }}</span>
              <br />
              <span>Email-Address :{{ row3.item.email }}</span>
            </template>
            <template slot="show_details" slot-scope="row4">
              <b-form-checkbox
                @change="row4.toggleDetails"
                v-model="row4.detailsShowing"
              ></b-form-checkbox>
            </template>

            <template slot="row-details" slot-scope="row4">
              <b-card style="background: whiteSmoke">
                <b>Access Given For :</b>

                <span
                  >{{ row4.item.departmentName1 }}
                  {{ row4.item.finalPagePermision }}</span
                >
                <br />
                <br />

                <b>Account Created On :</b>

                <span>{{ row4.item.loginTime }}</span>
              </b-card>
            </template>
          </b-table>
        </div>

        <div>
          <b-pagination
            limit="5"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </div>
      </b-card-text>
    </b-card>

    <!-- Additional Add User Client Modal Start -->
    <b-modal
      id="user-modal"
      ref="user-modal"
      title="Add User Client Details"
      size="lg"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <b-row>
        <b-col md="12">
          <label>
            Client
            <span class="error">*</span>
          </label>
          <multi-select
            :options="$store.getters['common/getAllMultiClientList']"
            :selected-options="client_items"
            v-model="clientUserForm.fk_multi_client_id"
            placeholder="Select Client"
            :multiple="true"
            id="Client"
            @select="SelectMultiClient"
          ></multi-select>
          <!-- <span class="error" v-if="!clientUserForm.fk_multi_client_id">
            {{ errorList.fk_multi_client_id }}
          </span> -->
        </b-col>
      </b-row>
      <b-button @click="SaveUser" variant="danger" class="pull-right">Save</b-button>
      <b-button @click="HideModalUser" variant="danger" class="pull-right">
        Close</b-button
      >
    </b-modal>
    <!-- Additional Add User Client Modal End -->

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import ClientUserService from "../../../services/ClientUserService.js";
import SendEmail from "../../common/sendEmail.vue";
import userBasedClient from "../../common/userBasedClient.vue";
import PurchaseApproverDetails from "../../common/purchaseApproverDetails.vue";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllMultiClientList",
      JSON.stringify({
        itemCode: "MultiClientList",
      })
    );
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    if (globalPermissionStatus("Main Master")) {
      this.$store.dispatch("setCurrentRoute", "/userManagement/viewUserDetail");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      //Added By Priyanshu Singh Multi Select Start
      Filter: {
        branchfilter: "",
        branchNamefilter: "",
      },
      branch_items: [],

      isCheckAll: false,
      AllUserIds: [],
      AllDepartmentId: [],
      AllEmailId: [],
      selectedAllUserIds: "",
      selectedDepartmentId: "",

      client_items: [],
      clientDetails: [],
      clientUserForm: {
        fk_multi_client_id: "",
        multi_client_name: "",
      },
      purchaseApproverPayload: {},

      fields: [
        {
          key: "isActive",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "employeeName",
          label: "Employee Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "username",
          label: "Employee Detail",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "email",
          label: "Contact Details",
          sortable: true,
          sortDirection: "desc",
        },
        // {
        //   key: "loginTime",
        //   label: "Creation Date",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },
        {
          key: "show_details",
          mainkey: "departmentName1",
          label: "More Details",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },
        {
          key: "acc_client_ids",
          label: "View Clients",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },
        {
          key: "userId",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },

        // {
        //   key: "chassisNo",
        //   label: "Chassis No.",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },
        // {
        //   key: "modNo",
        //   label: "Modal No",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },

        // {
        //   key: "driverName",
        //   label: "Driver Name",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // },
        // {
        //   key: "vehicleTruckId",
        //   label: "Action",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // }

        // {
        //   key: "age",
        //   label: "Person age",
        //   sortable: true,
        //   class: "text-center"
        // },
        // { key: "isActive", label: "is Active" },
        // { key: "actions", label: "Actions" }
      ],
      ExcelBtnName: "Export",
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },

      isLoading: true,
      alert: {
        content: "Added Succesfully",

        ok: "ok",
      },
      checked4: [],

      hubName: "",
      indexNew: "",
      switchVal: "",
      hubAddress: "",
      excelUpload: "",
      deleteId: "",
      adminToggle: this.$sessionsStorage.get("designation"),
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      vehicleSizeMaster: [],
      validate: true,
      hubNameError: "",
      hubNameError1: "",
      itemObj: {},
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {
    //this.JqueryFun()
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    // Loading,
    CustomLoader,
    ModelListSelect,
    MultiSelect,
    SendEmail,
    userBasedClient,
    PurchaseApproverDetails,
  },
  created() {
    eventBus.$on("sendMailID", (sendMailID) => {
      console.log("sendMailID=>", sendMailID);
      if (sendMailID.mail_id > 0) {
        this.$refs["addPop"].open();
      } else {
        this.$refs["addPop"].open();
      }
      this.alert.content = sendMailID.MSG;
      this.getData();
    });
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    viewClients(items) {
      this.$sessionsStorage.set("getAlacc_client_ids", "");
      this.$sessionsStorage.set("getUserID", "");
      if (items.acc_client_ids) {
        let acc_client_ids = items.acc_client_ids.split(",");
        let filteredArray = acc_client_ids.filter((value) => value !== null);
        // const result = acc_client_ids.replace(/null/g, '');
        filteredArray = filteredArray.toString();
        this.$sessionsStorage.set("getAlacc_client_ids", filteredArray);
      }
      this.$sessionsStorage.set("getUserID", items.userId);
      this.$sessionsStorage.set("getUsermultiClientName", items.multiClientName);

      this.$router.push({
        path: "/user/viewClientList",
      });
    },
    SelectMultiBranch(branch_items, lastSelectItem) {
      this.branch_items = branch_items;
      console.log("branch_items=>", this.branch_items);

      this.Filter.branchfilter = "";
      this.Filter.branchNamefilter = "";
      if (this.branch_items) {
        this.branch_items.forEach((item_val) => {
          if (this.Filter.branchNamefilter) {
            this.Filter.branchNamefilter =
              this.Filter.branchNamefilter + "," + item_val.text;
          } else {
            this.Filter.branchNamefilter = item_val.text;
          }

          if (this.Filter.branchfilter) {
            this.Filter.branchfilter = this.Filter.branchfilter + "," + item_val.value;
          } else {
            this.Filter.branchfilter = item_val.value;
          }
        });
        console.log("Filter=>", this.Filter);
      }
      this.SearchFilter();
    },
    SelectMultiClient(client_items, lastSelectItem) {
      this.client_items = client_items;
      this.clientDetails = client_items;
      console.log("clientDetails=>", this.clientDetails);

      this.clientUserForm.fk_multi_client_id = "";
      this.clientUserForm.multi_client_name = "";
      if (this.clientDetails) {
        this.client_items.forEach((item_val) => {
          if (this.clientUserForm.multi_client_name) {
            this.clientUserForm.multi_client_name =
              this.clientUserForm.multi_client_name + "," + item_val.text;
          } else {
            this.clientUserForm.multi_client_name = item_val.text;
          }

          if (this.clientUserForm.fk_multi_client_id) {
            this.clientUserForm.fk_multi_client_id =
              this.clientUserForm.fk_multi_client_id + "," + item_val.value;
          } else {
            this.clientUserForm.fk_multi_client_id = item_val.value;
          }
        });
        console.log("clientDetails=>", this.clientUserForm);
      }
    },
    ShowModalUser() {
      if (this.AllUserIds.length > 0) {
        this.$refs["user-modal"].show();
      } else {
        this.alert.content = "Please Select Atlease 1 User";
        this.$refs["addPop"].open();
      }
    },
    HideModalUser() {
      this.$refs["user-modal"].hide();
    },
    AddMultiClientUser() {
      let AllUser_ids_arr = this.AllUserIds;
      let AllDepartment_ids_arr = this.AllDepartmentId;
    },
    SaveUser() {
      if (this.AllUserIds.length > 0 && this.clientDetails.length > 0) {
        this.clientUserForm.AllUserIds = this.AllUserIds;
        this.clientUserForm.clientDetails = this.clientDetails;
        this.clientUserForm.TypeofAdd = "User Master Update";
        let payload = {
          itemCode: "updateUserDetails",
          clientUserForm: this.clientUserForm,
        };
        payload = JSON.stringify(payload);
        // return false;
        ClientUserService.getAllClientUserList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.getData();
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    SelectAll: function () {
      console.log("this.User List=>", this.vehicleSizeMaster);
      this.isCheckAll = !this.isCheckAll;
      this.AllUserIds = [];
      this.AllDepartmentId = [];
      this.AllEmailId = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.vehicleSizeMaster) {
          let single_data = "";
          this.AllUserIds.push(this.vehicleSizeMaster[key].userId);
          this.AllEmailId.push(this.vehicleSizeMaster[key].email);
          this.AllDepartmentId.push(this.vehicleSizeMaster[key].DepartmentId);
        }
        console.log("this.AllUserIds=>", this.AllUserIds);
        console.log("this.AllDepartmentId=>", this.AllDepartmentId);
        console.log("this.AllEmailId=>", this.AllEmailId);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (this.AllUserIds.length == this.vehicleSizeMaster.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.AllUserIds.includes(item.userId);
      if (istrue == true) {
        this.AllDepartmentId.push(item.DepartmentId);
        this.AllEmailId.push(item.email);
      } else {
        const index = this.AllDepartmentId.indexOf(item.DepartmentId);
        this.AllDepartmentId.splice(index, 1);
        const email_index = this.AllEmailId.indexOf(item.email);
        this.AllEmailId.splice(email_index, 1);
      }

      console.log("this.AllUserIds=>", this.AllUserIds);
      console.log("this.AllDepartmentId=>", this.AllDepartmentId);
      console.log("this.AllEmailId=>", this.AllEmailId);
    },
    SearchFilter() {
      this.getData();
    },
    ClearFilter() {
      this.Filter = {
        branchfilter: "",
        branchNamefilter: "",
      };
      this.getData();
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$router.push({
        path: "/userManagement/addUser",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#vehicleSizenew").DataTable();
      });
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;

      if (this.hubName == "") {
        $("#hubName").focus();
        this.hubNameError = "Enter Hub";
        validate_new = false;
      }
      if (this.hubAddress == "") {
        $("#hubAddress").focus();
        this.hubNameError1 = "Enter Address";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    viewUserPage(userID) {
      this.$sessionsStorage.set("editUserPerId", userID);
      this.$router.push({
        path: "/userManagement/addUser",
      });
    },

    getData() {
      this.vehicleSizeMaster = [];
      this.totalRows = 0;
      this.isLoading = true;
      let type_Size = {
        user: "0",
        userId: "",
        Filter: this.Filter,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/viewUser.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            }
            if (data.userDetails.length > 0) {
              console.log(data);
              this.vehicleSizeMaster = data.userDetails;
              this.totalRows = data.userDetails.length;
            }
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    downloadExcel() {
      let excelName = {
        excelName: "UserMaster",
        validExcel: "yes",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/downloadMasterExcel.php`,
        data: JSON.stringify(excelName),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            window.open(data.link12);
          }
        })
        .catch((error) => {});
    },

    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(`userMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
          this.getData();
        })
        .catch((err) => {
          throw err;
        });
    },
    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.userId;

      this.itemObj.isActive = this.itemObj.isActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "users",
        tableId: "userId",
        tableIsActive: "isActive",
        value1: this.itemObj.isActive,
        tableVal: this.deleteId,
        isMailSend: "No",
        manual: "No",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.vehicleSizeMaster[this.indexNew] = this.itemObj;
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    },
    onClose6(type) {
      if (type != "cancel") {
      } else {
        console.log(this.itemObj);
        this.vehicleSizeMaster[this.indexNew] = this.itemObj;
      }
    },
    // Added By Priyanshu Singh Start
    getReportsAss(id, btnName) {
      //this.isLoading = true;
      let excelIdGivin = "";
      if (id == "All_Users_Report") {
        excelIdGivin = "All_Users_Report";
      }
      let view_Users = {
        excelId: excelIdGivin,
        assignmentNo: "Users",
        searchVal: this.filter,
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      console.log(view_Users);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/reportsAgentColoderExcel.php`,
        data: JSON.stringify(view_Users),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.ExcelBtnName = btnName;
            if (data.excelName != undefined) {
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    // Added By Priyanshu Singh Start
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// viewUserDetail.vue?6573c839